const stateAction = {
  state: {
    activeAmountItemId: null,
    marketSelected: '',
    gameSlugSelected: '',
    userFreebets: 0
  },
  mutations: {
    setActiveAmountItemId(state: any, itemId: any) {
      state.activeAmountItemId = itemId;
    },

    setMarketSelected(state: any, marketSlug: any) {
      state.marketSelected = marketSlug;
    },

    setGameSlug(state: any, slug: string) {
      state.gameSlugSelected = slug;
    },

    setFreeBetCount(state: any, cnt: any) {
      state.userFreebets = cnt;
    }
  },
  actions: {},
  getters: {},
};

export default stateAction;
